import { render } from "./DeckCard.vue?vue&type=template&id=fd8893ac&scoped=true"
import script from "./DeckCard.vue?vue&type=script&lang=js"
export * from "./DeckCard.vue?vue&type=script&lang=js"

import "./DeckCard.vue?vue&type=style&index=0&id=fd8893ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8893ac"]])

export default __exports__